<template>
    <teleport to="body">
        <info-modal></info-modal>
    </teleport>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>